export default{
  name: '分组',
  permissionsKey: "JG-FZ",
  icon: 'el-icon-s-grid',
  path: '/grouping',
}
